import { Component, OnInit } from '@angular/core';
import { CUtilit } from './classes/utilit';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppToolbarService } from './components/toolbar/services/app-toolbar.service';
import { ArmaServConnection } from './classes/info-connection';
import { InitApp } from './classes/init-all';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { LoggedUserService } from './services/loged-user/loged-user.service';
import { OverviewComponent } from './pages/overview/overview.component';
import { CommandesComponent } from './pages/commandes/commandes.component';
import { ListDecoComponent } from './pages/list-deco/list-deco.component';
import { ListDnComponent } from './pages/list-dn/list-dn.component';
import { ListCertificatsComponent } from './pages/list-certificats/list-certificats.component';
import { ListFactureComponent } from './pages/list-facture/list-facture.component';
import { g_params } from './classes/global-param';
import {ArmaServServerMethods} from './classes/ArmaServServerMethods';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  HTML_LoadingInfo: string = ''; // Affiche sur le html ce qui est en train de se passer quand on init la page

  connected: boolean;

  private readonly mSubjectLoadingInfo: Subject<string>;  // Utiliser pour retourner les informations de la fonction initAll

  private chkConnectionInProgress: boolean = false;
  mErrorInitApp: string = '';

  constructor(private mHttp: HttpClient,
              private mArmaServMethod: ArmaServServerMethods,
              private router: Router,
              private mSnackBar: MatSnackBar,
              private mToolbarService: AppToolbarService,
              private mLoggedUser: LoggedUserService) {
    this.connected = true;
    this.mSubjectLoadingInfo = new Subject;
    this.mSubjectLoadingInfo.asObservable().subscribe(next => this.HTML_LoadingInfo = next);
  }

  ngOnInit(): void {
    this.initApp().then(value => {
      // Pour attendre la generation du dom (init de la toolbar)
      setTimeout(() => this.mToolbarService.refreshToolbar(false));
    });
  }

  /**
   * Premiere fonction utiliser pour initialiser la page
   * @param forceRefresh
   * TODO: à déplacer dans le init-all.ts
   */
  private async initApp(forceRefresh: boolean = false) {
    try {
      CUtilit.initUserParam();
      if (!g_params.g_appInit || forceRefresh) {
        const isSessionValid: boolean = await ArmaServConnection.isSessionValid(this.mHttp);
        const isConnected: boolean = await ArmaServConnection.isConnected(this.mHttp);
        if (
          (!isSessionValid) || // Si notre session n'est pas valide
          (!isConnected)       // Ou qque l'on est pas connecter a armaserv
        ) {
          //ArmaServConnection.LogoutArmawebAngular(this.router, this.mHttp);
          const goBackToLoginPage: boolean = (  // Si on est pas connecter on reviens toujours sur la page de login, exception pour
            this.router.url != '/login' &&    // Si on est déja sur la page de login
            this.router.url != '/dev'   &&    // Si on est sur la page de test dev
            this.router.url != '/shapes' &&   // Si on est sur la page des formes
            this.router.url != '/ticket' &&   // Si on est sur la pages pour ajouter un ticket
            !this.router.url.includes('/ticket') // Si on est sur la pages pour consulter les ticket
          );

          if (goBackToLoginPage) {
            this.router.navigateByUrl('login');
          }
          ArmaServConnection.removeArmaServeSessionInfo();  // Si notre session a expiré, on enleve l'id de la session
        }
        await this.checkArmaServConnection();
        await InitApp.initAll(this.mArmaServMethod, this.mLoggedUser, this.mSubjectLoadingInfo);

        g_params.g_appInit = true;
        console.log('Init OK :)');
      }
    } catch (e) {
      console.error('Error ini :(', e);
      if (e instanceof HttpErrorResponse)
        this.mErrorInitApp = (e as HttpErrorResponse).name + ', code: ' + (e as HttpErrorResponse).status + ' (' + (e as HttpErrorResponse).statusText + ')';
      else
        this.mErrorInitApp = 'Unknow error';
      alert(this.mErrorInitApp);
      g_params.g_appInit = false;
    }
  }

  /**
   * Evenement quand on change de page
   * Change le titre de la toolbar
   * Verifie les droit pour la page
   * @param event La class du composant qui est affiché
   */
  onActivate(event: any) {
    this.checkArmaServConnection()
      .then(isConnected => this.connected = isConnected)
      .catch(error => this.connected = false);
    this.mToolbarService.toolbarPageTitle = '';
    this.mToolbarService.resetToolBarElementVisibility();

    // On verifi si on à le droit d'acceder à cette pages, si pas autorisé alors on se redirige vers la page de login
    let allowed = true; // Par default on peut acceder a tout le site
    if (event instanceof OverviewComponent) {
      allowed = this.mLoggedUser.rightShowOverview;
    } else if (event instanceof CommandesComponent) {
      allowed = this.mLoggedUser.rightShowWebInput;
    } else if (event instanceof ListDecoComponent) {
      allowed = this.mLoggedUser.rightShowWebSiteFollowup;
    } else if (event instanceof ListDnComponent) {
      allowed = this.mLoggedUser.RightShowDeliveryList;
    } else if (event instanceof ListCertificatsComponent) {
      allowed = this.mLoggedUser.RightShowCertif;
    } else if (event instanceof ListFactureComponent) {
      allowed = this.mLoggedUser.RightShowInvoiceList;
    }
    if (!allowed) {
      this.router.navigateByUrl('').catch(console.error);
    }
  }

  async checkArmaServConnection(): Promise<boolean> {
    let result = true;
    if (!this.chkConnectionInProgress) {
      try {
        this.chkConnectionInProgress = true;
        if (!await ArmaServConnection.isSessionValid(this.mHttp)) {
          ArmaServConnection.LogoutArmawebAngular(this.router, this.mHttp);
          CUtilit.showAlertSessionExpired(this.mSnackBar);
        }
      } catch (e) {
        console.error(e);
        result = false;
      } finally {
        this.chkConnectionInProgress = false;
      }
    }
    return result;
  }

  reloadPage() {
    location.reload();
  }

  poweredByClick() {
    window.open('https://ariadis.fr');
  }

  get isInit() { return g_params.g_appInit; }

}
